'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatKeys = {
  MY: 'i18n.dateTime.monthAndYear',
  MD: 'i18n.dateTime.monthAndDay',
  QY: 'i18n.dateTime.quarterAndYear',
  WMDY: 'i18n.dateTime.weekDayAndMonthAndDayAndYear'
};

exports.default = function (_ref) {
  var value = _ref.value,
      type = _ref.type,
      format = _ref.format,
      length = _ref.length;

  var momentValue = !type ? value : _I18n2.default.moment[type](value);
  var monthName = '';
  var weekDay = '';
  var fullDate = '';

  if (length === 's') {
    var monthKeys = Object.keys(_I18n2.default.translations.en.i18n.dateTime.shortForm.months);
    var shortMonthKey = monthKeys[momentValue.month()];
    monthName = _I18n2.default.text('i18n.dateTime.shortForm.months.' + shortMonthKey, {
      locale: _I18n2.default.locale
    });

    weekDay = momentValue.format('ddd');
    fullDate = momentValue.format('ll');
  } else {
    monthName = momentValue.format('MMMM');
    weekDay = momentValue.format('dddd');
    fullDate = momentValue.format('LL');
  }

  var options = {
    monthName: monthName,
    locale: _I18n2.default.locale
  };

  switch (format) {
    case 'MD':
      options.dayNumber = momentValue.date();
      break;
    case 'QY':
      options.quarterNumber = momentValue.quarter();
      options.yearNumber = momentValue.year().toString();
      break;
    case 'WMDY':
      options.weekDay = weekDay;
      options.fullDate = fullDate;
      break;
    default:
      options.yearNumber = momentValue.year().toString();
  }

  return _I18n2.default.text(formatKeys[format], options);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/internal/utils/formatAbstractDate.js
// module id = 38
// module chunks = 177